function Hauszeitung_form(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);
    this.articleId = null;
    this.containerId = null;

    this.selectors = {
      formParent: 'form[data-i4-decorator="Validator_form"]',
      statusSelect: 'select[name="status"]',
      fieldDateStart: 'input#date_start',
      fieldDateEnd: 'input#date_end',
      fieldPriority: 'select[name="priority"]',
      fieldDocumentTitle: 'input#document_title',
      hiddenUploadDocument: '.f-document input.js-hidden-uploaded-file',
      hiddenFilemanagerId: 'input#filemanager_id',
      articleIdField: '#hauszeitung_article_id',
      clearImagesButton: '#clear_images',
    };

    this.triggers = {
      validate: 'i4:validate',
      refresh: 'i4:refresh',
      documentChange: 'i4:change',
    };

    this.init = function() {
      this.$formParent = this.$element.find(this.selectors.formParent);

      this.$statusSelect = this.$element.find(this.selectors.statusSelect);
      this.$fieldDateStart = this.$element.find(this.selectors.fieldDateStart);
      this.$fieldDateEnd = this.$element.find(this.selectors.fieldDateEnd);
      this.$fieldPriority = this.$element.find(this.selectors.fieldPriority);

      this.$fieldDocumentTitle = this.$element.find(this.selectors.fieldDocumentTitle);
      this.$hiddenUploadDocument = this.$element.find(this.selectors.hiddenUploadDocument);
      this.$hiddenFilemanagerId = this.$element.find(this.selectors.hiddenFilemanagerId);

      this.$clearImagesButton = this.$element.find(this.selectors.clearImagesButton);
      this.$articleIdField = this.$element.find(this.selectors.articleIdField);

      this.articleId = this.$articleIdField.val();

      this.$statusSelect.on('change', this.$statusSelectChange.bind(this));
      this.$clearImagesButton.on('click', this.$clearImages.bind(this));
      this.$element.on(this.triggers.documentChange, this.$onHiddenUploadDocumentChange.bind(this));

      this.$evaluateDocumentTitleRequired();
    };

    this.$statusSelectChange = function(event) {
      const newStatus = event.target.value;

      if (newStatus === 'active') {
        this.$fieldDateStart.attr('data-required', 1);
        this.$fieldDateEnd.attr('data-required', 1);
        this.$fieldPriority.attr('data-required', 1);
      } else {
        this.$fieldDateStart.attr('data-required', 0);
        this.$fieldDateEnd.attr('data-required', 0);
        this.$fieldPriority.attr('data-required', 0);
      }

      this.$fieldDateStart.trigger(this.triggers.validate);
      this.$fieldDateEnd.trigger(this.triggers.validate);
      this.$fieldPriority.trigger(this.triggers.validate);
      this.$formParent.trigger(this.triggers.validate);
    };

    this.$onHiddenUploadDocumentChange = (event) => {
      if (event.target.parentElement.className.includes('f-document')) {
        const documentId = this.$hiddenUploadDocument.val();
        if (Number(documentId) > 0) {
          // console.log('%c UPDATE document title required ', 'background-color: red; color: white;');
          this.$fieldDocumentTitle.attr('data-required', 1);
        } else {
          // console.log('%c UPDATE NOT document title required ', 'background-color: green; color: white;');
          this.$fieldDocumentTitle.attr('data-required', 0);
        }
        this.$fieldDocumentTitle.trigger(this.triggers.validate);
        this.$formParent.trigger(this.triggers.validate);
      }
    };

    this.$evaluateDocumentTitleRequired = () => {
      const hiddenFilemanagerIdValue = this.$hiddenFilemanagerId.val();
      if (Number(hiddenFilemanagerIdValue) > 0) {
        setTimeout(() => {
          // console.log('%c INIT document title required ', 'background-color: red; color: white;');
          this.$fieldDocumentTitle.attr('data-required', 1);
          this.$fieldDocumentTitle.trigger(this.triggers.validate);
          this.$formParent.trigger(this.triggers.validate);
        }, 500);
      }
    };

    this.$clearImages = () => {
      const param = jQuery.param({
        js: 'Hauszeitung',
        call: 'article_clear_images',
        article_id: this.articleId,
      });

      i4_Ajax.factory().
        set_parameter(param).
        set_option({
          on_success: ((response) => {
            response = JSON.parse(response);
            // console.log('this.popup', this.popup);
            this.popup.remove(this.$element);
            this.popup.$instance = null;

            setTimeout(() => {
              const call = {
                article_id: this.articleId,
                call: "edit",
                container_id: this.containerId,
                js: "Hauszeitung"
              };

              i4_Popup.add().set_option({
                ajax_param: JSON.parse(JSON.stringify(call)),
                position: 'cursor',
                loader: true
              }).run();
            }, 250);

          }).bind(this)
        }).
        run();
    };
}
